module.exports = __webpack_public_path__ + "static/media/23-5.df5eb425.mp3";